module.exports = __webpack_public_path__ + "media/images/redesign-images/textures/texture-2-a8bd01fe089ecdb9bccec5f8abba1374.svg";